import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { useCurrentUser } from '@/hooks'

interface Props {
  isAdminRequired?: boolean
  isViewerRequired?: boolean
  isUserRequired?: boolean
}

export const ProtectedRoute = ({
  isAdminRequired,
  isViewerRequired,
  isUserRequired,
  children
}: PropsWithChildren<Props>) => {
  const { currentUser, isViewer, isAdmin, isUser } = useCurrentUser()

  if (isAdminRequired && !isAdmin) return <Navigate to="/" replace />

  if (isViewerRequired && !isViewer) return <Navigate to="/" replace />

  if (isUserRequired && !isUser) return <Navigate to="/" replace />

  if (!currentUser) return <Navigate to="/" replace />

  return <>{children}</>
}
